import { Component } from "@angular/core";
import { LoginComponent } from "../login/login.component";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
  styles: ``,
  imports: [LoginComponent],
})
export class LoginPageComponent {}
